import { combineReducers } from "redux";
import tutorials from "./tutorials";
import inventoryReducer from './changeStateReducer';
import userReducer from './userReducer';
import messageReducer from './messageReducer'
import changeStateReducer from "./changeStateReducer";
export default combineReducers({
  tutorials,
  inventorys: inventoryReducer,
  auth: userReducer,
  message: messageReducer,
  changeState: changeStateReducer
});
